// @noflow
import type { Action, State as AppState } from './types';
import { hasSideloading } from '../utilities/receiver';

const initialState: AppState = {
  baselineShown: false,
  currentTheme: 'danyOneDefaultTheme',
  error: null,
  menuShown: false,
  mobileTitle: '',
  floatingTvRemoteShown: false,
  online: false,
  storageIsReady: false,
  carousels: {},
  activeReceiver: undefined,
  changeReceiverError: false,
  viewport: undefined,
};

const reducer = (state: AppState = initialState, action: Action): AppState => {
  // Map all app errors into state.app.error.
  // In React Native, we show errors in one nicely animated unobtrusive alert.
  // In the browser, we prefer local error messages rendering.
  // TODO: Refactor it. We don't want sticky strings.

  let carousels;

  if (action.type.endsWith('_FAIL')) {
    // $FlowFixMe
    state = { ...state, error: action.payload.error };
  }

  switch (action.type) {
    case 'APP_ERROR':
      return { ...state, error: action.payload.error };

    case 'APP_SHOW_MENU':
      return { ...state, menuShown: action.payload.menuShown };

    case 'APP_ONLINE':
      return { ...state, online: action.payload.online };

    case 'STORAGE_READY':
      return { ...state, storageIsReady: true };

    case 'APP_VIEWPORT_CHANGED':
      return { ...state, viewport: action.payload };

    case 'TOGGLE_BASELINE':
      return { ...state, baselineShown: !state.baselineShown };

    case 'TOGGLE_FLOATING_TV_REMOTE_VIEW':
      return { ...state, floatingTvRemoteShown: !state.floatingTvRemoteShown };

    case 'HIDE_FLOATING_TV_REMOTE_VIEW':
      return { ...state, floatingTvRemoteShown: false };

    case 'SET_THEME':
      return { ...state, currentTheme: action.payload.theme };

    case 'SET_MOBILE_TITLE':
      return { ...state, mobileTitle: action.payload };

    case 'RECEIVE_CAROUSEL':
      carousels = { ...state.carousels };
      carousels[action.carouselName] = action.payload;
      return { ...state, carousels };

    case 'CHANGE_ACTIVE_RECEIVER':
      return { ...state, changeReceiverError: false };

    case 'CHANGE_ACTIVE_RECEIVER_SUCCESS': {
      const {
        receiverId,
        nickname,
        finderId,
        slingAdmin,
        model,
        state: status,
        canRecord,
        zipCode,
        stbSoftwareVersion,
        stbUtcOffset,
      } = action;

      return {
        ...state,
        activeReceiver: {
          canRecord,
          receiverId,
          nickname,
          model,
          status,
          finderId,
          slingAdmin,
          hasSideloading: hasSideloading(model),
          zipCode,
          stbSoftwareVersion,
          stbUtcOffset,
        },
      };
    }

    case 'CHANGE_ACTIVE_RECEIVER_ERROR':
      return { ...state, changeReceiverError: true };
    // $FlowExpectedError
    case 'SIGN_OUT': {
      /* We must clean all user and STB related data from store on sign-out */
      return { ...state, activeReceiver: undefined };
    }

    case 'RECEIVE_RECEIVERS_STATUS': {
      const updatedReceivers: Array<ReceiverStatus> = action.payload;
      const activeReceiverId = state.activeReceiver?.receiverId;
      const updatedActiveReceiver = updatedReceivers?.find(r => r.receiver_id === activeReceiverId);

      return {
        ...state,
        activeReceiver: { ...state.activeReceiver, ...(updatedActiveReceiver || {}) },
      };
    }
    case 'REQUEST_RECEIVER_REBOOT': {
      const {
        payload: { receiverId },
      } = action;
      const activeReceiverId = state.activeReceiver?.receiverId;

      return activeReceiverId === receiverId
        ? { ...state, activeReceiver: { ...state.activeReceiver, status: 'reboot' } }
        : state;
    }
    case 'REQUEST_TV_REMOTE_ACTION':
      return state;
    case 'REQUEST_TV_REMOTE_ACTION_SUCCESS':
      return state;
    case 'REQUEST_TV_REMOTE_ACTION_ERROR':
      return state;

    default:
      /* Following line assures switch exhaustiveness */
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
